<div class="page">
  <!-- ===== HEADER PRINCIPAL ===== -->
  <div class="card highlight">
    <div class="highlight-header">
      <div class="header-text">
        <h1>{{ 'rapport.header.title' | translate }}</h1>
        <button class="btn-refresh" (click)="refreshRapports()" [disabled]="refreshing" [title]="'rapport.header.refresh' | translate">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" [class.spinning]="refreshing">
            <path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8"/>
            <path d="M21 3v5h-5"/>
            <path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16"/>
            <path d="M3 21v-5h5"/>
          </svg>
          <span>Refresh</span>
        </button>
      </div>
      <div class="iso-badge">
        <span class="iso-text">ISO</span>
        <span class="iso-number">15189</span>
      </div>
    </div>

    <div class="highlight-content">
      <div *ngIf="rapports.length && getDernierRapport(); else noReportState" class="rapport-featured">
        <div class="featured-info">
          <p class="last-label">{{ 'rapport.featured.lastAvailable' | translate }}</p>
          <h2>{{ getMonthLabel($safeNavigationMigration(getDernierRapport()?.mois)) }}</h2>
          <p class="periode">{{ getDernierRapport()?.periode }}</p>
        </div>
        <button class="btn-primary" (click)="telecharger(getDernierRapport()!)" [disabled]="downloading">
          <svg *ngIf="!downloading" width="16" height="16" viewBox="0 0 24 24" fill="none">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M7 10l5 5 5-5M12 15V3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <svg *ngIf="downloading" width="16" height="16" viewBox="0 0 24 24" fill="none" class="spinner">
            <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" fill="none" stroke-dasharray="31.416" stroke-dashoffset="31.416">
              <animate attributeName="stroke-dasharray" dur="2s" values="0 31.416;15.708 15.708;0 31.416" repeatCount="indefinite"/>
              <animate attributeName="stroke-dashoffset" dur="2s" values="0;-15.708;-31.416" repeatCount="indefinite"/>
            </circle>
          </svg>
          {{ (downloading ? 'rapport.downloading' : 'rapport.featured.downloadPdf') | translate }}
        </button>
      </div>

      <ng-template #noReportState>
        <div class="no-report-state">
          <div class="no-report-icon">📄</div>
          <p class="no-report-text">{{ 'rapport.noReport.title' | translate }}</p>
          <p class="no-report-subtitle">{{ 'rapport.noReport.subtitle' | translate }}</p>
        </div>
      </ng-template>
    </div>
  </div>

  <!-- ===== LISTE DES RAPPORTS ===== -->
  <div class="card">
    <div class="card-header">
      <div class="header-content">
        <div>
          <h2>{{ 'rapport.list.title' | translate }}</h2>
          <p class="subtitle">{{ 'rapport.list.subtitle' | translate }}</p>
        </div>
        <button class="btn-secondary" (click)="telechargerSelection()"
                [disabled]="!hasSelection() || downloading">
          {{ downloading ? ('rapport.downloading' | translate) : ('rapport.list.downloadSelection' | translate: { count: getSelectionCount() }) }}
        </button>
      </div>
    </div>

    <div class="rapport-list" *ngIf="rapports.length > 0; else emptyState">
      <div *ngFor="let annee of getAnnees()" class="annee-section">
        <div class="annee-header" (click)="toggleAnnee(annee)">
          <span class="annee-titre">{{ annee }}</span>
          <span class="toggle-icon">{{ isAnneeOuverte(annee) ? '▼' : '▶' }}</span>
        </div>
        <div class="annee-content" *ngIf="isAnneeOuverte(annee)">
          <div *ngFor="let r of getRapportsParAnnee()[annee]" class="rapport-item">
            <input type="checkbox" [(ngModel)]="r.selectionne" (click)="$event.stopPropagation()" />
            <div class="rapport-info" (click)="toggleSelection(r)">
              <span class="mois">{{ getMonthLabel(r.mois) }}</span>
              <span class="periode">{{ r.periode }}</span>
              <span class="date-generation" *ngIf="r.dateGeneration">{{ 'rapport.generatedOn' | translate: { date: r.dateGeneration } }}</span>
              <span class="tag" *ngIf="r.dernier">{{ 'rapport.lastReportTag' | translate }}</span>
            </div>
            <button class="btn-download" (click)="telecharger(r)" [disabled]="downloading">
              {{ downloading ? '...' : '⬇' }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <ng-template #emptyState>
      <div class="empty-state">
        <div class="empty-icon">📄</div>
        <h3>{{ 'rapport.noReport.title' | translate }}</h3>
        <p>{{ 'rapport.noReport.subtitle' | translate }}</p>
      </div>
    </ng-template>
  </div>
</div>